<template>
  <v-dialog
    v-model="internalOpen"
    max-width="600"
    persistent
    @input="onDialogToggle"
  >
    <v-card>
      <v-card-title class="headline grey lighten-2">
        Manage Event Time &amp; Bus Stop
        <v-spacer />
        <v-btn icon @click="closeDialog">
          <v-icon>fal fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 v-if="!timeOnly">
            <h3 class="subtitle-1 mb-2">Select Bus Stop</h3>
            <v-autocomplete
              v-if="internalOpen"
              v-model="selectedBusStop"
              :items="busStopSearchResults"
              :loading="busStopApiInProgress"
              :search-input.sync="busStopSearchKeywords"
              item-text="name"
              item-value="id"
              clearable
              hide-no-data
              hide-selected
              return-object
              label="Search by name or OTP ID"
              placeholder="Start typing to search for bus stops"
              :menu-props="{ maxHeight: 300, contentClass: 'bus-stop-autocomplete-menu', offsetY: true }"
            >
              <template v-slot:append-outer>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" @click="viewBusStopInMap">
                      fas fa-map-marker-alt
                    </v-icon>
                  </template>
                  <span>View bus stop in map</span>
                </v-tooltip>
              </template>
              <template slot="item" slot-scope="{ item }">
                <div style="width: 100%">
                  <div>{{ item.name }}</div>
                  <div v-if="item.externalName || item.externalId" class="caption grey--text">
                    OTP: {{ item.externalName }}<span v-if="item.externalId"> ({{ item.externalId }})</span>
                  </div>
                </div>
              </template>
              <template slot="selection" slot-scope="{ item }">
                <div>{{ item.name }}</div>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs12 v-if="!timeOnly && showBusStopMap" class="mt-2">
            <v-card>
              <v-card-title class="py-1 px-2">
                <span class="subtitle-2">Bus stop location</span>
                <v-spacer />
                <v-btn icon small @click="hideBusStopMap">
                  <v-icon small>fas fa-times</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text class="pa-0">
                <div style="height: 200px;">
                  <st-map
                    v-if="stMapApis"
                    disable-search
                    height="200px"
                    :on-map-loaded="onBusStopMapLoaded"
                    :on-bus-stop-clicked="onBusStopClicked"
                    container-id="eventBusStopMap"
                    :mapbox-access-token="mapboxAccessToken"
                    :maptiler-key="maptilerKey"
                    :api="stMapApis"
                    :center-at-long-lat="longLatOnMap"
                  />
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 class="mt-3" v-if="!timeOnly">
            <h3 class="subtitle-1 mb-2">Override label (optional)</h3>
            <v-text-field
              v-model="form.label"
              label="Label to display instead of bus stop name"
            />
          </v-flex>
          <v-flex xs12 class="mt-3" v-if="!busStopOnly">
            <h3 class="subtitle-1 mb-2">Pickup time</h3>
            <div :class="timeOnly ? '' : 'layout justify-center'">
              <time-field
                v-if="internalOpen"
                v-model="pendingTimeValue"
                :other-props="{ hideDetails: true, placeholder: 'e.g. 8:00am' }"
              />
              <div class="ml-3" v-if="!timeOnly">
                <v-btn
                  small
                  color="primary"
                  :disabled="!isAdmin"
                  @click="addPendingTime"
                >
                  <v-icon left small>fal fa-plus</v-icon>
                  Add time
                </v-btn>
              </div>
            </div>
            <div class="mt-2" v-if="selectedTimesDisplay && selectedTimesDisplay.length">
              <div class="caption grey--text mb-1">Selected times</div>
              <v-chip
                v-for="t in selectedTimesDisplay"
                :key="t.raw"
                class="ma-1"
                small
                close
                :disabled="!isAdmin"
                @input="removeSelectedTime(t.raw)"
              >
                {{ t.display }}
              </v-chip>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn flat color="warning" @click="closeDialog">
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          :disabled="!isAdmin"
          @click="onSave"
        >
          Set
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import src from './src'
export default src
</script>
